/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/
/** @packageDocumentation
 * @module Common
 */

/**
 * Enumeration for horizontal alignment.
 * @public
 */
export enum HorizontalAlignment {
  Left = "left",
  Center = "center",
  Right = "right",
  Justify = "justify",
}

/**
 * Enumeration for vertical alignment.
 * @public
 */
export enum VerticalAlignment {
  Top = 1,
  Middle = 2,
  Bottom = 3,
}
